import React from 'react'
import { DoneOutline } from '@mui/icons-material'
import { Grid, Paper, Typography } from '@mui/material'
import ResponsiveButton from '@components/ResponsiveButton'

const customBranded = {
  price: 'SR 24,000',
  features: [
    'Add the logo of your school on the splash Screen',
    'Add the slogan of your school',
    'Customize the welcome screen (the splash screes) as you want',
    'Change text fonts, colors, background color',
    'Control what to show and what to hide on the app',
  ],
}

function Custom() {
  return (
    <Paper sx={{ p: 6 }}>
      <Typography
        variant="body2"
        fontWeight={700}
        sx={{ pb: 2 }}
      >
        Have A Custom Branded App For:
      </Typography>
      <Grid
        container
        spacing={1}
        alignItems="flex-end"
        sx={{ pb: 6 }}
      >
        <Grid
          item
          xs
        >
          <Typography
            variant="h4"
            fontWeight={700}
            color="primary.main"
          >
            {customBranded.price}
          </Typography>
        </Grid>
        <Grid
          item
          sx={{ display: { xs: 'none', md: 'block' } }}
        >
          <ResponsiveButton
            color="secondary"
            variant="contained"
            aria-label="get started free"
          >
            Get Started
          </ResponsiveButton>
        </Grid>
      </Grid>
      <Grid
        container
        spacing={3}
      >
        {customBranded.features.map((feature, index) => (
          <Grid
            item
            xs={12}
            key={index}
          >
            <Grid
              container
              spacing={2}
              alignItems="center"
            >
              <Grid item>
                <DoneOutline color="primary" />
              </Grid>
              <Grid item>
                <Typography
                  variant="h6"
                  fontWeight={500}
                  display="inline"
                >
                  {feature}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
        ))}
      </Grid>
      <ResponsiveButton
        color="secondary"
        variant="contained"
        aria-label="get started free"
        sx={{
          mt: 5,
          display: { xs: 'block', md: 'none' },
          marginLeft: 'auto',
          marginRight: 'auto',
        }}
      >
        Get Started
      </ResponsiveButton>
    </Paper>
  )
}

export default Custom
